import COUNTRIES from './countries.json'

export default function hasFlag(country) {
	return COUNTRIES.indexOf(country) >= 0
}